import _ from 'lodash';
import HttpAdapter from './lib/standard_gateway/http_adapter';
import Observable from 'scripts/lib/observable_mixin';

export default class FbApiGateway {
  constructor(backend) {
    this._isSdkLoaded = false;
    this.http = new HttpAdapter(backend);
    this.loginToFb.bind(this);
    this.setSdkLoaded.bind(this);
  }

  init({ orgId }) {
    this.orgId = orgId;
  }

  /** Note: _loginToFbAsync must be called before the loadSdk method.
   * The function assigned to global.fbAsyncInit is run as soon as the SDK has completed loading.
   * Given that subsequent FB Page authorizations will be associated with the appId, it is
   * important that the appId configuraton is not changed on the backend.
   */
  _loginToFbAsync({ appId, version, scope }) {
    global.fbAsyncInit = () => {
      global.FB.init({
        version,
        appId,
        xfbml: true,
        cookie: true,
      });
      this.setSdkLoaded();
      this.loginToFb(appId, version, scope);
    };
  }

  setSdkLoaded() {
    this._isSdkLoaded = true;
  }

  loadSdk() {
    (function(d, s, id) {
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }

  requestFbPages(authResponse) {
    return this.http
      .get(`/api/facebook/v1/orgs/${this.orgId}/me/account`, {
        headers: { 'X-Gladly-AccessToken': authResponse.accessToken },
      })
      .then(pages => this.notifyObservers('handleRequestFbPagesSuccess', pages))
      .catch(error => this.notifyObservers('handleRequestFbPagesError', error));
  }

  loginToFb(appId, version, scope) {
    if (!this._isSdkLoaded) {
      this._loginToFbAsync({ appId, version, scope });
      this.loadSdk();
      return;
    }

    global.FB.login(
      response => {
        if (response.authResponse) {
          this.requestFbPages(response.authResponse);
        } else {
          this.notifyObservers('handleLoginError', null);
        }
      },
      { scope }
    );
  }
}

_.extend(FbApiGateway.prototype, Observable);



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/fb_api_gateway.js